/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * See Focal theme documentation for events: variant:changed, variant:added, cart:updated, cart:refresh.
 */

/* =========================================================================
   OZ LINER GUARD (added 05-10-2026)
   Keeps "Detachable Thermal Liner (Add-on)" quantity in the cart
   no higher than the quantity of the garment it was added for.
   - Garment line carries property "Thermal Liner"; liner line carries "For" = garment title.
   - If a garment is reduced/removed, its liner is reduced/removed too.
   - A liner added on its own (no "For" property) is never touched.
   ========================================================================= */
(function () {
  if (window.__ozLinerGuard) return; window.__ozLinerGuard = true;
  var LINER_VARIANT = 50615890084037;
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var running = false, again = false;

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' failed'); return r.json(); });
  }

  function canReload() {
    try {
      var s = JSON.parse(sessionStorage.getItem('ozLinerGuardReload') || 'null');
      var now = Date.now();
      if (s && now - s.t < 15000 && s.n >= 2) return false;
      sessionStorage.setItem('ozLinerGuardReload', JSON.stringify({ t: s && now - s.t < 15000 ? s.t : now, n: s && now - s.t < 15000 ? s.n + 1 : 1 }));
    } catch (e) {}
    return true;
  }

  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var allowed = {}, used = {}, fixes = [];
        cart.items.forEach(function (it) {
          if (Number(it.variant_id) === LINER_VARIANT) return;
          if (it.properties && it.properties['Thermal Liner']) {
            allowed[it.product_title] = (allowed[it.product_title] || 0) + it.quantity;
          }
        });
        cart.items.forEach(function (it) {
          if (Number(it.variant_id) !== LINER_VARIANT) return;
          var forTitle = it.properties && it.properties['For'];
          if (!forTitle) return;
          var left = (allowed[forTitle] || 0) - (used[forTitle] || 0);
          var keep = Math.max(0, Math.min(it.quantity, left));
          used[forTitle] = (used[forTitle] || 0) + keep;
          if (keep !== it.quantity) fixes.push({ id: it.key, quantity: keep });
        });
        if (!fixes.length) return false;
        return fixes.reduce(function (p, f) {
          return p.then(function () { return post('cart/change.js', f); });
        }, Promise.resolve()).then(function () { return true; });
      })
      .then(function (changed) {
        if (!changed) return;
        if (/\/cart\/?$/.test(window.location.pathname)) { if (canReload()) window.location.reload(); return; }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (e) { console.warn('OZ liner guard:', e); })
      .then(function () {
        running = false;
        if (again) { again = false; setTimeout(reconcile, 300); }
      });
  }

  document.addEventListener('cart:updated', function () { setTimeout(reconcile, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile); else reconcile();
})();
